var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUprn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0037 11.2123V4.66227C23.0037 4.018 22.4808 3.49512 21.8365 3.49512H19.6691C19.0248 3.49512 18.502 4.018 18.502 4.66227V7.35372",
    stroke: "#E37D28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49609 12.4982L12.4808 4.79734C13.355 4.04802 14.6447 4.04802 15.5189 4.79734L24.5048 12.4982",
    stroke: "#E37D28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99707 11.2119V22.1691C4.99707 23.4588 6.04167 24.5035 7.33138 24.5035H12.8333",
    stroke: "#E37D28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5048 24.5038L22.5918 22.5908",
    stroke: "#E37D28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5144 15.167C21.9153 15.167 23.8609 17.1138 23.8609 19.5135C23.8609 21.9131 21.9141 23.8599 19.5144 23.8599C17.1148 23.8599 15.168 21.9143 15.168 19.5135C15.168 17.1126 17.1148 15.167 19.5144 15.167",
    stroke: "#E37D28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUprn);
export default __webpack_public_path__ + "static/media/noUPRN.c20e9c49.svg";
export { ForwardRef as ReactComponent };